import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function TargetAudience() {
  const items = ['Lideras equipos de ventas', 'Eres vendedor/a de alto desempeño', 'Ya has logrado resultados', 'Pero sabes que seguir así no es sostenible', 'Y estás listo/a para diseñar, no improvisar, tu 2026'];
  return <section className="py-24 bg-slate-50 text-slate-900" data-id="element-146">
      <div className="max-w-4xl mx-auto px-4" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-16 border border-slate-200 shadow-lg text-center" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-bold mb-12" data-id="element-149">
            Este entrenamiento es para ti si:
          </h2>

          <div className="space-y-4 text-left max-w-xl mx-auto" data-id="element-150">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-4 p-4 rounded-xl hover:bg-slate-50 transition-colors" data-id="element-151">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center" data-id="element-152">
                  <Check className="w-5 h-5 text-amber-600" data-id="element-153" />
                </div>
                <span className="text-lg md:text-xl text-slate-800 font-medium" data-id="element-154">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}